/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UnreadNotificationsSubscriptionSubscriptionVariables = {};
export type UnreadNotificationsSubscriptionSubscriptionResponse = {
    readonly viewerNotifications: {
        readonly unreadBroadcastNotifications: number;
    };
};
export type UnreadNotificationsSubscriptionSubscription = {
    readonly response: UnreadNotificationsSubscriptionSubscriptionResponse;
    readonly variables: UnreadNotificationsSubscriptionSubscriptionVariables;
};



/*
subscription UnreadNotificationsSubscriptionSubscription {
  viewerNotifications {
    unreadBroadcastNotifications
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadBroadcastNotifications",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnreadNotificationsSubscriptionSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerNotifications",
        "kind": "LinkedField",
        "name": "viewerNotifications",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnreadNotificationsSubscriptionSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerNotifications",
        "kind": "LinkedField",
        "name": "viewerNotifications",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76b6de8660438f2a6bc37abdc936da96",
    "id": null,
    "metadata": {},
    "name": "UnreadNotificationsSubscriptionSubscription",
    "operationKind": "subscription",
    "text": "subscription UnreadNotificationsSubscriptionSubscription {\n  viewerNotifications {\n    unreadBroadcastNotifications\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '4bb8bf1846ede6f1c12df0e07275ce6d';
export default node;
